import { useLazyQuery, useMutation } from "@apollo/client";
import {
  getVisionComments,
  visionWordsAndCommentsMutation
} from "GraphQL/mutation/visionCommentBoard";
import { get } from "lodash";
import { useRecoilValue } from "recoil";
import { loggedInUserDetails } from "Recoil/LoggedInUserDetail/selector";
import { FETCH_POLICY } from "src/constants";
import { checkArrayLength, getUserId } from "src/utils";

const { useForm } = require("react-hook-form");

export const useVisionComments = () => {
  let _loggedInUserDetails = useRecoilValue(loggedInUserDetails);
  const defaultValues = {
    loading: false,
    commentLoading: false,
    reactionLoading: false,
    visionId: "",
    comments: [],
    commentText: "",
    parentMessageId: "0",
    createdBy: {
      firstName: _loggedInUserDetails.firstName,
      lastName: _loggedInUserDetails.lastName,
      profileImage: _loggedInUserDetails.profileImage
    }
  };
  const methods = useForm({
    defaultValues: defaultValues,
    mode: "onBlur"
  });

  const [getAllVisionComments] = useLazyQuery(getVisionComments, {
    fetchPolicy: FETCH_POLICY.networkOnly,
    onCompleted: data => {
      const { setValue } = methods;
      setValue("commentLoading", false);
      setValue("comments", get(data, "getVisionComments", []));
    }
  });

  const [commentMutation] = useMutation(visionWordsAndCommentsMutation);

  const addComment = (variables, fetchData) => {
    commentMutation({ variables }).then(({ data }) => {
      fetchData(
        data.visionWordsAndCommentsMutation,
        variables.input.parentMessageId
      );
    });
  };

  const reactionComment = ({ data, reaction, listOfComments, setValue }) => {
    setValue("reactionLoading", { [reaction]: true });
    let isLiked = true;
    const comments = [...listOfComments];

    const { createdBy } = defaultValues;
    if (reaction === "Like") {
      isLiked = checkArrayLength(data.usersGivenLike) ? false : true;
    } else {
      isLiked = checkArrayLength(data.usersGivenLove) ? false : true;
    }
    const variables = {
      input: {
        id: data.id,
        visionId: data.visionId,
        responseType: reaction,
        createdByUserId: getUserId(),
        loveLikeResponse: { isLiked, userId: getUserId() }
      }
    };

    commentMutation({ variables })
      .then(() => {
        const idx = comments.findIndex(c => c.id === data.id);
        // if isLiked true
        if (idx >= 0) {
          const liked = {
            usersGivenLike: [],
            usersGivenLove: []
          };
          if (isLiked) {
            if (reaction === "Like") {
              liked.usersGivenLike = [{ ...createdBy }];
              liked.usersGivenLove = [];
            } else {
              liked.usersGivenLove = [{ ...createdBy }];
              liked.usersGivenLike = [];
            }
          }
          comments[idx] = { ...comments[idx], ...liked };
          setValue("comments", comments);
        }
        setValue("reactionLoading", {});
      })
      .catch(() => {
        // add snack bar
        setValue("reactionLoading", {});
      });
  };

  const removeNewFlagMutation = (variables, fetchData) => {
    // console.log("varaibles", variables);
    // commentMutation({ variables }).then(({ data }) => {
    //   fetchData(
    //     data.visionWordsAndCommentsMutation,
    //     variables.input.parentMessageId
    //   );
    // });
  };
  return {
    methods,
    getAllVisionComments,
    addComment,
    reactionComment,
    removeNewFlagMutation
  };
};
